<template>
  <div class="row m-0 position-relative d-flex flex-column mobile pt-2">
    <div class="w-50 w-sm-100 m-md-auto">
      <div class="" v-if="!enableOTP">
        <div
          class="error-message error-text"
          v-if="
            validateInput(error, 'nousernametext', null) ||
            validateInput(error, 'phone', null) ||
            validateInput(error, 'email', null)
          "
        >
          <div v-if="validateInput(error, 'email', null)">
            Please enter a valid email address
          </div>
          <div v-else-if="validateInput(error, 'phone', null)">
            Please enter a valid phone number
          </div>
          <div v-else-if="validateInput(error, 'nousernametext', null)">
            Please enter your email address or mobile number
          </div>

          <div v-else>Please enter a valid ${fetch_data.type}</div>
        </div>

        <div class="d-flex w-100 pure-material-textfield-outlined my-2">
          <label
            v-if="fetch_data.type == 'phone'"
            :class="{
              'sign-in': number === true,
              'error-input': errorInput === true,
              'error-no-input': validateInput(error, 'nousernametext', true),
            }"
            class="w-100 pure-material-textfield-outlined my-2 d-flex"
          >
            <input
              id="username"
              name="username"
              placeholder=" "
              v-model.trim="fetch_data.mask_username"
              @keyup.enter="processSignIn"
              v-on:focus="resetError"
              v-on:keyup="updatenumber();clearError();"
              autocomplete="off"
              autofocus
            />
            <span>Enter Email Address</span>
          </label>
          <AIntTelephone
            v-else
            :placeholder="'Enter Phone Number'"
            validateStatus="success"
            :phoneInput="phoneInput"
            @change="mobileInputChange"
          ></AIntTelephone>
        </div>
        <div class="pt-3 d-flex">
          <button
              class="btn-danger mdc-theme--primary-shape-bg w-100 go-back mr-2"
              name="SubmitLogin"
              type="submit"
              v-on:click="back"
            >
              Back
            </button>
          <button
            class="btn-danger mdc-theme--primary-shape-bg w-100"
            name="SubmitLogin"
            type="submit"
            v-on:click="clearError();verifyUsername()"
          >
            Continue
          </button>
        </div>
      </div>
      <div v-else>
        <div class="">
          <div
            class="error-message error-text"
            v-if="validateInput(error, 'nootptext', null)"
          >
            <div>Please enter otp</div>
          </div>
          <div class="0">
            <div class="pb-2 pt-2">
              <span class="text-message"
                >Please enter the OTP (One Time Password) sent to
              </span>
              <span v-if="fetch_data.type == 'email'" class="verify-title"
                >{{ fetch_data.isdcode }}{{ fetch_data.mobile }}</span
              >
              <span class="verify-title pr-2" v-else>{{
                fetch_data.email
              }}</span>
            </div>

            <label
              :class="{
                'error-input': errorInput === true,
                'error-no-input': validateInput(error, 'nootptext', true),
              }"
              class="w-100 pure-material-textfield-outlined my-2"
            >
              <input
                @keyup.enter="verifyUser"
                placeholder=" "
                v-model="otp"
                v-on:focus="resetError"
              />
              <span>Enter OTP</span>
            </label>

            <div class="pt-3 d-flex bg-transparent">
              <button
                class="
                  btn-danger
                  mdc-theme--primary-shape-bg
                  w-100
                  go-back
                  mr-2
                "
                name="SubmitLogin"
                type="submit"
                v-on:click="ShowIdentificationField"
              >
                Back
              </button>
              <button
                class="btn-danger mdc-theme--primary-shape-bg w-100"
                name="SubmitLogin"
                type="submit"
                v-on:click="verifyMappedUsername"
              >
                Verify
              </button>
            </div>

            <ResendOtp
              @generateOTP="generateOTP"
              :startResendOtpInterval="startInterval"
            ></ResendOtp>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Services from "../services";
import Validation from "./mixins/Validation";
import CountryCode from "./mixins/CountryCode";
import CommonCode from "./mixins/CommonCode";
import ResendOtp from "./views/ResendOTP.vue";
import UserUtils from "./mixins/UserUtils";
import { EventBus } from "../events";
import { AIntTelephone } from "@canvas/componentlibrary";
import { SHELL_APP_HEADER_ICON } from "./mixins/Global";
export default {
  mixins: [Validation, CountryCode, CommonCode, UserUtils],

  components: {
    ResendOtp,
    AIntTelephone,
  },

  data() {
    return {
      otp: null,
      fetch_data: null,
      phoneInput: {
        number: "",
        initialisationOptions: {
          allowDropdown: true,
          formatOnDisplay: true,
          nationalMode: true,
          initialCountry: "in",
          preferredCountries: ["in", "sg", "my", "sa"],
          separateDialCode: true,
        },
      },
      enableOTP: false,
      maskUsernameRequestID: null,
      startInterval: false,
    };
  },
  mounted() {
    this.fetch_data = this.$route.params;

    if (this.fetch_data.username) {
      this.setTitle(`Please Provide Your ${
          this.fetch_data.type == "email" ? "Mobile number" : "Email Address"
        } `)
    } else {
      this.$router.push({ name: this.getGuestDefaultPage() }, () => {});
    }
  },
  methods: {
    setTitle(title){
      this.$store.commit("projects/SET_HEADER_TITLE", {
        title: title,
        showBackIcon: false,
      });
      this.sendPostMessageToShellApp("UI_CHANGE", {
        headerTitle: title,
        setHeaderIcon: SHELL_APP_HEADER_ICON.BACK,
      });
    },
    loginVerifiedIdentity() {
      const username =
        this.fetch_data.type == "phone"
          ? this.fetch_data.isdcode + this.fetch_data.username
          : this.fetch_data.username;
      const payload = {
        mapped_username: this.fetch_data.mask_username,
        username: username,
        username_request_id: this.fetch_data.requestId,
        username_type: this.fetch_data.type,
      };
      
      Services.sendPayload(payload,'verified-identity',this.$route.query.login_challenge)
        .then((response) => {
          if (response.data.requestId) {
            this.startInterval = true;
            this.maskUsernameRequestID = response.data.requestId;
            this.enableOTP = true;
            this.setTitle('Verify');
            
          } else {
            const callBackAfterOtpVerified = () => {
              this.lemniskCbExecuted = true;
              this.windowRedirection(response.data.redirect_uri);
            };
            this.pushOtpVerfiedcaptureEvents(
              response,
              callBackAfterOtpVerified
            );
          }
        })
        .catch((error) => {
          if (error.response.data.error_code == 15 || error.response.data.error_code == 14) {
            this.$store.commit("projects/SET_NOTIFICATION_TOKEN", {
              msg: "Unable to log in? Please contact us at care@livspace.com",
              errorCode: error.response.status,
            });
          } else {
            this.$store.commit("projects/SET_NOTIFICATION_TOKEN", {
              msg: error.response.data.message,
              errorCode: error.response.status,
            });
          }
        });
    },
    generateOTP() {
      this.loginVerifiedIdentity();
    },
    ShowIdentificationField() {
      this.enableOTP = false;
      this.startInterval = false;
      if (this.saved_timerInterval) clearInterval(this.saved_timerInterval);
      this.$store.commit("projects/SET_NOTIFICATION_TOKEN", {
        msg:null,
        errorCode: 0,
      });
      this.otp=null;
      this.setTitle(`Please Provide Your ${
          this.fetch_data.type == "email" ? "Mobile number" : "Email Address"
        } `)
    },

    verifyUsername() {
      this.error = {};
      if (!this.fetch_data.mask_username) {
        if (this.fetch_data.type === "email") {
          this.error.phone = true;
        } else {
          this.error.email = true;
        }
        return false;
      } else {
        let filter = /^[0-9-+]+$/;
        if (filter.test(this.fetch_data.mask_username)) {
          if (
            this.isPhoneValid(
              this.fetch_data.mask_username,
              this.fetch_data.isdcode
            )
          ) {
            this.fetch_data["mobile"] = this.fetch_data.mask_username;
          } else {
            this.errorInput = true;
            this.error.phone = true;
            return false;
          }
        } else {
          if (this.isEmailValid(this.fetch_data.mask_username)) {
            this.fetch_data["email"] = this.fetch_data.mask_username;
          } else {
            this.errorInput = true;
            this.error.email = true;
            return false;
          }
        } //API call
        this.loginVerifiedIdentity();
      }
    },

    verifyMappedUsername() {
      this.error = {};

      if (!this.otp) {
        this.error.nootptext = true;
        return false;
      }
      const username =
        this.fetch_data.type == "phone"
          ? this.fetch_data.isdcode + this.fetch_data.username
          : this.fetch_data.username;
      const payload = {
        mapped_username: this.fetch_data.mask_username,
        username: username,
        username_request_id: this.fetch_data.requestId,
        username_type: this.fetch_data.type,
        mapped_username_request_id: this.maskUsernameRequestID,
        otp: this.otp,
      };
      Services.sendPayload(payload,'verify-mapped-identity',this.$route.query.login_challenge)
      
        .then((response) => {
          const callBackAfterOtpVerified = () => {
            this.lemniskCbExecuted = true;
            this.windowRedirection(response.data.redirect_uri);
          };
          this.pushOtpVerfiedcaptureEvents(response, callBackAfterOtpVerified);
        })
        .catch((error) => {
          const analyticsData={
            username: this.fetch_data.username
          }
          EventBus.$emit(
            "captureEvents",
            "accounts_login:otp_verification_failed",
            analyticsData,
          );
          if (error.response.data.error_code == 15 || error.response.data.error_code == 14) {
            this.$store.commit("projects/SET_NOTIFICATION_TOKEN", {
              msg: "Unable to log in? Please contact us at care@livspace.com",
              errorCode: error.response.status,
            });
            this.enableOTP = false;
            this.otp=null;
            this.setTitle(`Please Provide Your ${
              this.fetch_data.type == "email" ? "Mobile number" : "Email Address"
            } `)
          } else {
            this.$store.commit("projects/SET_NOTIFICATION_TOKEN", {
              msg: error.response.data.message
                ? error.response.data.message
                : "Error",
              errorCode: error.response.status,
            });
          }
        });
    },

    mobileInputChange(event) {
      this.fetch_data.isdcode =
        "+" + event.intlTelInputSettings.activeItem.dataset.dialCode;
      this.fetch_data.countryCode =
        event.intlTelInputSettings.activeItem.dataset.countryCode;
      this.phoneInput.number = event.number;
      this.fetch_data.mask_username = this.phoneInput.number;
      //this.showCountryCode(this.fetch_data.mask_username);
    },

    updatenumber() {
      this.phoneInput.number = this.fetch_data.mask_username;
    },
  
 
    pushOtpVerfiedcaptureEvents(response, eventCallBack) {
      let analyticsData = {};
      let identifyEventObj = {};
      if (response && response.data && response.data.user) {
        const { user } = response.data;
        analyticsData = {
          name: user.name,
          email: user.email,
          phoneNo: user.phone,
          customerId: user.customerId,
        };
        identifyEventObj = {
          customerId: user.customerId,
          otpVerified: 1,
        };
      }
      //reset lemniskCbExecuted flag if already set
      if (this.lemniskCbExecuted) this.lemniskCbExecuted = false;
      let backTo = window.localStorage.getItem("backTo");
      if (backTo && backTo.includes("/lead-quiz")) {
        let queryParams = backTo.split("?")[1];
        const urlParams = new URLSearchParams(queryParams);
        const leadId = urlParams.get("id");
        //send identify event also for otp verified scenario
        //so passing identifyEventObj as fourth param
        EventBus.$emit(
          "captureEvents",
          "accounts_lead-form:otp_verified",
          {
            ...analyticsData,
            leadId,
          },
          eventCallBack,
          identifyEventObj
        );
      } else {
        //send identify event also for otp verified scenario
        //so passing identifyEventObj as fourth param
        EventBus.$emit(
          "captureEvents",
          "accounts_login:otp_verified",
          analyticsData,
          eventCallBack,
          identifyEventObj
        );
      }
      //explicitly call our callback in case of lemnisk fails
      this.handleCallbackIfEventFails(
        eventCallBack,
        "callBackAfterOtpVerified"
      );
    },
  },
 
};
</script>
<style scoped>
.verify-title {
  font-size: 16px;
  font-family: "Roboto", sans-serif;
  line-height: 24px;
  font-weight: 500;
  color: #1a1a1a;
}
.go-back {
  background: transparent;
  border: 1px solid #eb595f !important;
  color: #eb595f !important;
  font-weight: 500;
}

.go-back:hover {
  color: white !important;
}
</style>